import { throttle } from "lodash-es";

const AUDIO_THROTTLE = 8000;

const handRaiseAudio = new Audio("/sounds/handraise.mp3");
const breakoutAudio = new Audio("/sounds/breakout_chime.mp3");
const tickingAudio = new Audio("/sounds/ticking.mp3");
const timerEndAudio = new Audio("/sounds/timer_notification.mp3");
const testAudio = new Audio("/sounds/test_sound.mp3");

const maybePlayAudio = (audio: HTMLAudioElement) => {
  // May throw an autoplay error if the user hasn't interacted with the page yet
  try {
    audio.play();
  } catch (error) {
    console.warn("Error playing audio", error);
  }
};

export const playHandRaiseAudio = throttle(
  () => {
    maybePlayAudio(handRaiseAudio);
  },
  AUDIO_THROTTLE,
  { trailing: false },
);

export const playBreakoutAudio = () => {
  maybePlayAudio(breakoutAudio);
};

export const playTickingAudio = () => {
  maybePlayAudio(tickingAudio);
};

export const playTimerEndAudio = () => {
  maybePlayAudio(timerEndAudio);
};

export const playTestAudio = (audioStoppedCallback: () => void) => {
  maybePlayAudio(testAudio);
  testAudio.onended = audioStoppedCallback;
  testAudio.onerror = audioStoppedCallback;
};

export const stopTickingAudio = () => {
  tickingAudio.pause();
  tickingAudio.currentTime = 0;
};
